import TextField from 'Shared/components/TextField'
import useQuestionTranslate from 'FlowBuilder/hooks/useQuestionTranslate'
import { questionTranslatablesBase, questionTranslatablesName, questionTranslatablesOptIn, questionTranslatablesScore, questionTranslatablesResponseConfirmation } from 'FlowBuilder/lib/questionTranslatable'
import { useLanguagesData } from 'FlowBuilder/hooks/useLanguageFlow'
import './TranslationSettings.scoped.scss'
import AnswerTranslateSettings from './AnswerTranslateSettings'
import TranslatableHtmlField from './TranslatableHtmlField'
import { useAct } from 'FlowBuilder/store'

export default function QuestionTranslateSettings({ question }) {
  const answers = useSel(s => s.answers.entities)
  const { editableLanguagesData } = useLanguagesData()
  const numColumns = Object.keys(editableLanguagesData).length + 1

  if (question.questionType == 'opt_in_radio') {
    return <div className="translatable-question-settings" 
      style={{gridTemplateColumns: `repeat(${numColumns}, 1fr)`}}>
      {Object.keys(questionTranslatablesOptIn).map((strKey) => (
        <QuestionTranslateSetting question={question} translatable={questionTranslatablesOptIn[strKey]} strKey={strKey} key={strKey} />
      ))}
    </div>
  }

  if (question.questionType == 'name') {
    return <div className="translatable-question-settings" 
      style={{gridTemplateColumns: `repeat(${numColumns}, 1fr)`}}>
      {Object.keys(questionTranslatablesName).map((strKey) => (
        <QuestionTranslateSetting question={question} translatable={questionTranslatablesName[strKey]} strKey={strKey} key={strKey} />
      ))}
    </div>
  }

  if (question.questionType == 'score') {
    return <div className="translatable-question-settings"
      style={{gridTemplateColumns: `repeat(${numColumns}, 1fr)`}}>
      {Object.keys(questionTranslatablesScore).map((strKey) => (
        <QuestionTranslateSetting question={question} translatable={questionTranslatablesScore[strKey]} strKey={strKey} key={strKey} />
      ))}
    </div>
  }

  if (question.questionType == 'responses_confirmation') {
    return <div className="translatable-question-settings" 
      style={{gridTemplateColumns: `repeat(${numColumns}, 1fr)`}}>
      {Object.keys(questionTranslatablesResponseConfirmation).map((strKey) => (
        <QuestionTranslateSetting question={question} translatable={questionTranslatablesResponseConfirmation[strKey]} strKey={strKey} key={strKey} />
      ))}
    </div>
  }

  return <div className="translatable-question-settings" 
    style={{gridTemplateColumns: `repeat(${numColumns}, 1fr)`}}>
    {Object.keys(questionTranslatablesBase).map((strKey) => (<>
      <QuestionTranslateSetting question={question} translatable={questionTranslatablesBase[strKey]} strKey={strKey} />
      {answers && Object.values(answers).filter(a => a.questionId == question.id).map((answer) => (
        <AnswerTranslateSettings questionName={question.question} answerId={answer.id} key={answer.id} />
      ))}
    </>))}
  </div>
}

function QuestionTranslateSetting({ question, strKey, translatable }) {
  const { editableLanguagesData } = useLanguagesData()

  return <>
    <div className="translatable-label">
      <span><strong>{question.question}</strong></span>
      <span>{translatable.label }</span>
    </div>
    {Object.keys(editableLanguagesData).map((lang) => (
      <QuestionTranslateLanguageSetting
        key={lang}
        question={question}
        strKey={strKey}
        translatable={translatable}
        languageOverride={lang}
      />
    ))}
  </>
}

function QuestionTranslateLanguageSetting({ question, strKey, translatable, languageOverride }) {
  const act = useAct()
  const {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag,
  } = useQuestionTranslate({ questionId: question.id, languageOverride: languageOverride })

  function openHtmlEditor() {
    act.local.setModal({
      kind: 'editContent',
      fieldKind: 'questionTextContent',
      questionId: question.id,
      slug: strKey,
      wysiwyg: true,
      language: languageOverride,
    })
  }

  return <div className={`translatable-input translatable-input-${languageOverride} translatable-input-${strKey}`}>
    <span>{flag}</span>
    {translatable.html ? (
      <TranslatableHtmlField
        value={translated[strKey] || ''}
        placeholder={fallback[strKey] || translatable.default || question.question}
        onClick={openHtmlEditor}
      />
    ) : (
      <TextField
        key={question.id + strKey + languageOverride}
        value={translated[strKey] || ''}
        placeholder={fallback[strKey] || translatable.default || question.question}
        onChange={(val) => textContentUpdater(strKey, val)}
      />
    )}
  </div>
}
